// Progress bar component

import { useCurrentStep, useStepLabels } from '@/hooks';

export function ProgressBar() {
  const currentStep = useCurrentStep();
  const stepLabels = useStepLabels();
  const totalSteps = stepLabels.length;
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="progress-bar">
      <div className="progress-bar__track" />
      <div
        className="progress-bar__fill"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
